import React from 'react'
import { useThemeTokens } from '../../themes'

interface CardProps {
  children: React.ReactNode
  className?: string
  onClick?: () => void
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick
}) => {
  const theme = useThemeTokens()
  
  const cardStyles: React.CSSProperties = {
    backgroundColor: theme.colors.surface,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.borderRadius.md,
    padding: theme.spacing.md,
    boxShadow: theme.shadows.sm,
    cursor: onClick ? 'pointer' : 'default',
    transition: 'all 0.2s ease',
  }
  
  return (
    <div style={cardStyles} className={className} onClick={onClick}>
      {children}
    </div>
  )
}

interface CardHeaderProps {
  children: React.ReactNode
  className?: string
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  children,
  className = ''
}) => {
  const theme = useThemeTokens()
  
  const headerStyles: React.CSSProperties = {
    marginBottom: theme.spacing.md,
  }
  
  return (
    <div style={headerStyles} className={className}>
      {children}
    </div>
  )
}

interface CardTitleProps {
  children: React.ReactNode
  className?: string
}

export const CardTitle: React.FC<CardTitleProps> = ({
  children,
  className = ''
}) => {
  const theme = useThemeTokens()
  
  const titleStyles: React.CSSProperties = {
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.text,
    margin: 0,
    fontFamily: theme.typography.fontFamily,
  }
  
  return (
    <h3 style={titleStyles} className={className}>
      {children}
    </h3>
  )
}

interface CardContentProps {
  children: React.ReactNode
  className?: string
}

export const CardContent: React.FC<CardContentProps> = ({
  children,
  className = ''
}) => {
  return (
    <div className={className}>
      {children}
    </div>
  )
} 